export default __webpack_public_path__ + "3b67cd864e0aceb03d947a89938a0e14.svg";